import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const model = 'cars/car';
const wizardName = 'Driver association';
const wizardObject = 'Driver';
const wizardAction = 'personAssociation';

const PersonAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const carRecordId = params?.id ?? params?.car?.id ?? params?.car?._id ?? null;
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart, carRecordId);
    const car = params?.car ?? item?.data;

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "person_information": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "assignment_start_at": {
                                "type": "date",
                                "className": "col-6",
                                "placeholder": "insert"
                            },
                            "assignment_end_at": {
                                "type": "date",
                                "className": "col-6",
                                "placeholder": "insert"
                            },
                            "associated": {
                                "type": "personlist",
                                "defaultSelectedValues":[],
                                "enableSelection":true,
                                "disableMultipleRowSelection":car?.isPool ? false : true,
                                "dataProviderName":"persons/person",
                                "className": "col-12",
                                "required": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])
    
    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    const driver = car?.pools?.map((pool) => pool.employment?.person)[0];
    
    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ 
                "id": car?._id ?? car?.id
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            alertMessage={(car?.isPool == 'false' && typeof driver != 'undefined') && t('This operation will terminate the actual assignment to {{firstname}} {{lastname}}', {firstname:driver.firstname, lastname:driver.lastname})}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Select a {{wizardObject}} to be associated to {{carIdentifier}}', { wizardObject:wizardObject, carIdentifier: (car?.plate ? car.plate : car?.setup?.make+" "+car?.setup?.model) })} 
                />
            }
            {...params}
        />
    </>
}

export default PersonAssociation;


